/* tslint:disable:indent */
import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {LogService} from '../../../../shared/services/log.service';
import {FormsEnum} from '../../../../../models/enums/forms.enum';

@Component({
  selector: 'app-eforms-component',
  templateUrl: './eforms-component.component.html'
})
export class EformsComponentComponent implements OnInit {


  private LOG: LogService = new LogService(EformsComponentComponent);
  public noticeTypeBh: BehaviorSubject<any> = new BehaviorSubject(null);


  title = 'eForms - POC';
  public forms: Array<string> = [];
  @Input() indexPage: any;
  @Input() validationIndex: number;
  @Input() formGroup: FormGroup;
  @Input() formulaireName: FormsEnum;
  @Input() currentJson: any = new BehaviorSubject(null);
  @Input() linkForRouter: string;

  public eformsFormGroup: FormGroup = new FormGroup({});

  constructor() {
  }

  ngOnInit(): void {
    this.formGroup.addControl('eforms', this.eformsFormGroup);
    this.noticeTypeBh.next(this.formulaireName);
  }
}
